<template lang="pug">
  tbody
    tr
      th {{ $t("ui.sportsbook") }} MMO
      th {{ soccer_hdp_title }}
      td
        PTSelect(
          ref="soccer_hdp_upline_pt"
          :dirty="$v.soccer_hdp_upline_pt.$dirty"
          :error="$v.soccer_hdp_upline_pt.$error"
          :options="soccer_hdp_upline_options"
          :value="soccer_hdp_upline_pt"
          @input="input_soccer_hdp_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_hdp_account_pt"
          :dirty="$v.soccer_hdp_account_pt.$dirty"
          :error="$v.soccer_hdp_account_pt.$error"
          :options="soccer_hdp_account_options"
          :value="soccer_hdp_account_pt"
          @input="input_soccer_hdp_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_hdp_upline_remaining"
          :dirty="$v.soccer_hdp_upline_remaining.$dirty"
          :error="$v.soccer_hdp_upline_remaining.$error"
          :options="soccer_hdp_account_options"
          :value="soccer_hdp_upline_remaining"
          @input="input_soccer_hdp_upline_remaining"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_hdp_account_min"
          :dirty="$v.soccer_hdp_account_min.$dirty"
          :error="$v.soccer_hdp_account_min.$error"
          :options="soccer_hdp_min_options"
          :value="soccer_hdp_account_min"
          @input="input_soccer_hdp_account_min"
          :disabled="loading"
        )
    tr
      th {{ $t("ui.parlay") }} MMO
      th {{ parlay_title }}
      td
        PTSelect(
          ref="parlay_upline_pt"
          :dirty="$v.parlay_upline_pt.$dirty"
          :error="$v.parlay_upline_pt.$error"
          :options="parlay_upline_options"
          :value="parlay_upline_pt"
          @input="input_parlay_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="parlay_account_pt"
          :dirty="$v.parlay_account_pt.$dirty"
          :error="$v.parlay_account_pt.$error"
          :options="parlay_account_options"
          :value="parlay_account_pt"
          @input="input_parlay_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="parlay_upline_remaining"
          :dirty="$v.parlay_upline_remaining.$dirty"
          :error="$v.parlay_upline_remaining.$error"
          :options="parlay_account_options"
          :value="parlay_upline_remaining"
          @input="$v.parlay_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="parlay_account_min"
          :dirty="$v.parlay_account_min.$dirty"
          :error="$v.parlay_account_min.$error"
          :options="parlay_min_options"
          :value="parlay_account_min"
          @input="$v.parlay_account_min.$model = $event"
          :disabled="loading"
        )
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect
  },
  props: {
    loading: false,
    accountID: "",
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      soccer_hdp_upline_pt: 0,
      soccer_hdp_account_pt: 0,
      soccer_hdp_upline_remaining: 0,
      soccer_hdp_account_min: 0,
      parlay_upline_pt: 0,
      parlay_account_pt: 0,
      parlay_upline_remaining: 0,
      parlay_account_min: 0
    }
  },
  validations: {
    soccer_hdp_upline_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          total = value
        } else {
          total = value + this.soccer_hdp_account_pt
        }
        if(total < this.soccer_hdp_upline_min) {
          return false
        } else {
          return true
        }
      }
    },
    soccer_hdp_account_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          return true
        } else {
          total = value + this.soccer_hdp_upline_pt
          if(total < this.soccer_hdp_upline_min) {
            return false
          } else {
            return true
          }
        }
      }
    },
    soccer_hdp_upline_remaining: {
      required
    },
    soccer_hdp_account_min: {
      required
    },
    parlay_upline_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          total = value
        } else {
          total = value + this.parlay_account_pt
        }
        if(total < this.parlay_upline_min) {
          return false
        } else {
          return true
        }
      }
    },
    parlay_account_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          return true
        } else {
          total = value + this.parlay_upline_pt
          if(total < this.parlay_upline_min) {
            return false
          } else {
            return true
          }
        }
      }
    },
    parlay_upline_remaining: {
      required
    },
    parlay_account_min: {
      required
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    soccer_hdp_title: function () {
      return this.$t("ui.hdp") + "/" + this.$t("ui.ou") + " (" + this.soccer_hdp_upline_min + "%-" + this.soccer_hdp_upline_max + "%)"
    },
    soccer_hdp_upline_min: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'HDPMMO', 'SOCCER', 'account_min')
    },
    soccer_hdp_upline_max: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'HDPMMO', 'SOCCER', 'account_pt')
    },
    soccer_hdp_account_max: function() {
      return this.soccer_hdp_upline_max - this.soccer_hdp_upline_pt
    },
    soccer_hdp_upline_options: function() {
      return this.$helpers.getPTRateList(this.soccer_hdp_upline_max)
    },
    soccer_hdp_account_options: function() {
      return this.$helpers.getPTRateList(this.soccer_hdp_account_max)
    },
    soccer_hdp_min_options: function() {
      return this.$helpers.getPTRateList(this.soccer_hdp_account_pt)
    },
    parlay_title: function() {
      return this.$t("ui.parlay") + " (" + this.parlay_upline_min + "%-" + this.parlay_upline_max + "%)"
    },
    parlay_upline_min: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'PARLAYMMO', 'PARLAYMMO', 'account_min')
    },
    parlay_upline_max: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'PARLAYMMO', 'PARLAYMMO', 'account_pt')
    },
    parlay_account_max: function() {
      return this.parlay_upline_max - this.parlay_upline_pt
    },
    parlay_upline_options: function() {
      return this.$helpers.getPTRateList(this.parlay_upline_max)
    },
    parlay_account_options: function() {
      return this.$helpers.getPTRateList(this.parlay_account_max)
    },
    parlay_min_options: function() {
      return this.$helpers.getPTRateList(this.parlay_account_pt)
    }
  },
  mounted: function() {
    if(this.$helpers.isAgentLevel()) {
      this.$v.soccer_hdp_upline_pt.$model = this.soccer_hdp_upline_max
      this.$v.parlay_upline_pt.$model = this.parlay_upline_max
    }
  },
  methods: {
    input_soccer_hdp_upline_pt(e) {
      this.$v.soccer_hdp_upline_pt.$model = e
      this.$v.soccer_hdp_account_pt.$model = this.soccer_hdp_account_max

      if (this.soccer_hdp_upline_remaining > this.soccer_hdp_account_max) {
        this.$v.soccer_hdp_upline_remaining.$model = 0
      }
      if (this.soccer_hdp_account_min > this.soccer_hdp_account_pt) {
        this.$v.soccer_hdp_account_min.$model = 0
      }
      this.$emit("clicked")
    },
    input_soccer_hdp_account_pt(e) {
      this.$v.soccer_hdp_account_pt.$model = e
      if (this.soccer_hdp_account_min > this.soccer_hdp_account_pt) {
        this.$v.soccer_hdp_account_min.$model = 0
      }
      this.$emit("clicked")
    },
    input_soccer_hdp_upline_remaining(e) {
      this.$v.soccer_hdp_upline_remaining.$model = e
      this.$emit("clicked")
    },
    input_soccer_hdp_account_min(e) {
      this.$v.soccer_hdp_account_min.$model = e
      this.$emit("clicked")
    },
    input_parlay_upline_pt(e) {
      this.$v.parlay_upline_pt.$model = e
      this.$v.parlay_account_pt.$model = this.parlay_account_max
      if (this.parlay_upline_remaining > this.parlay_account_max) {
        this.$v.parlay_upline_remaining.$model = 0
      }
      if (this.parlay_account_min > this.parlay_account_max) {
        this.$v.parlay_account_min.$model = 0
      }
    },
    input_parlay_account_pt(e) {
      this.$v.parlay_account_pt.$model = e
      if (this.parlay_account_min > this.parlay_account_pt) {
        this.$v.parlay_account_min.$model = 0
      }
    }
  }
}

</script>